export var getMaxDate = function (d1, d2) { return (d1 > d2 ? d1 : d2); };
export var getMinDate = function (d1, d2) { return (d1 < d2 ? d1 : d2); };
